import React, {Fragment} from "react";
import CopyToClipboard from "../../copyToClipBoard";

export default function Coupon(props) {

    if (!props.coupon) {
        return null;
    }

    return <div className="feedback__coupon-box">
        <div className="feedback__content">
            <div className="feedback__left-area">
                <p className="feedback__coupon-txt">Here is your unique thank you coupon for <span>30% OFF</span> your next purchase at CareerHunter.</p>
                <p className="feedback__small-txt"><span className="small-icons blue-off-tooltip"/>Also sent to your email and is active for 1 year.</p>
            </div>
            <div className="feedback__right-area">
                <div className="feedback__copy-coupon">
                    <CopyToClipboard hoverButton={true} name={'couponCode'} value={props.coupon} msg={'Coupon code copied to clipboard'} />
                </div>
            </div>
        </div>
    </div>

}